import { render, staticRenderFns } from "./SellerOrdersHeader.vue?vue&type=template&id=229410b6&"
import script from "./SellerOrdersHeader.vue?vue&type=script&lang=ts&"
export * from "./SellerOrdersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SellerOrdersHeader.vue?vue&type=style&index=0&id=229410b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports